import { useFormikContext } from 'formik';

import { formatPrice } from 'utils/helpers';
import { getCheckChange } from 'utils/cart';

import * as Styles from './styles';
import { CheckFormValues } from './types';

// Owner 19 Oct 2026: a check written for more than the amount due shows the
// change to hand back, live, under the amount.
export const ChangeDue = ({ remainder }: { remainder: number }) => {
  const { values } = useFormikContext<CheckFormValues>();
  const change = getCheckChange(+values.amount, remainder);

  if (!(change > 0)) {
    return null;
  }

  return (
    <Styles.ChangeDue role="status">
      Change due: {formatPrice(change)}
    </Styles.ChangeDue>
  );
};
